import { useQueryClient } from "@tanstack/react-query"
import { extractApiErrorMessage } from "@velizhanin-dev/api-errors"
import { Trash2 } from "lucide-react"
import { useNavigate } from "react-router-dom"
import { toast } from "sonner"
import { type Broadcast, broadcastKeys, deleteBroadcast } from "@/entities/broadcast"
import { Button } from "@/shared/ui/button"
import { useConfirm } from "@/shared/ui/confirm-provider"

/** Удаление рассылки с подтверждением; после удаления: к списку рассылок. */
export function useDeleteBroadcast(botId: string, broadcast: Broadcast) {
	const navigate = useNavigate()
	const queryClient = useQueryClient()
	const { confirm } = useConfirm()
	return () =>
		confirm({
			title: `Удалить «${broadcast.name}»?`,
			message:
				broadcast.status === "DRAFT"
					? "Черновик удалится насовсем."
					: "Удалится и статистика доставки. Отправленные сообщения останутся у пользователей.",
			confirmText: "Удалить",
			onConfirm: async () => {
				try {
					await deleteBroadcast(botId, broadcast.id)
				} catch (error) {
					toast.error(extractApiErrorMessage(error, "Не удалось удалить рассылку"))
					return
				}
				queryClient.removeQueries({ queryKey: broadcastKeys.detail(botId, broadcast.id) })
				await queryClient.invalidateQueries({ queryKey: broadcastKeys.list(botId) })
				navigate(`/admin/bots/${botId}/broadcasts`, { replace: true })
			},
		})
}

export function DeleteButton({ botId, broadcast }: { botId: string; broadcast: Broadcast }) {
	const remove = useDeleteBroadcast(botId, broadcast)
	if (broadcast.status === "SENDING") return null
	return (
		<Button variant="ghost" className="w-full text-red-400" onClick={remove}>
			<Trash2 />
			Удалить
		</Button>
	)
}
